import App from '@/App.vue'
import { permissions } from '@/utils/permissions'
import { registerPlugins } from '@core/utils/plugins'
import { createApp } from 'vue'

// Styles
import '@core-scss/template/index.scss'
import '@mdi/font/css/materialdesignicons.css'
import '@styles/styles.scss'
import 'remixicon/fonts/remixicon.css'

// Create vue app
const app = createApp(App)

app.config.globalProperties.$can = permissions.can
app.config.globalProperties.$canAny = permissions.canAny

// Register plugins
registerPlugins(app)

// Mount vue app
app.mount('#app')
